import { ApplicationInterface, ApplicationMetaInterface } from '@interface/application/application.interface';
import { BaseStoreInterface } from '@interface/store/base-store.interface';
import { BaseStoreStructure } from '@util/constants/store.constants';

export const initialApplicationsState: BaseStoreInterface<
  Record<string, ApplicationInterface>,
  ApplicationMetaInterface
> = {
  ...BaseStoreStructure,
  data: {},
  meta: {
    currentId: '',
    accessToken: '',
  },
};
